import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useInput } from '../../../../../../customHook/useInput';
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks';
// import { renameCalendar } from '../../../../../../store/slices/calendarSlice';
import zeplinColor from '../../../../../../theme/Color';
import CustomCard from '../../../../../shared/CustomCard/CustomCard';
import CustomModal from '../../../../../shared/CustomModal/CustomModal';
import CustomTextField from '../../../../../shared/CustomTextField/CustomTextField';
import { fetchAllAccounts } from '../../../../../../store/slices/calendarSlice';
import { CalendarService } from '../../../../../../service/calendar.service';

const CalendarRename = ({
  handleClose,
  isModalOpen,
  calendarDetails,
}: {
  handleClose: () => void;
  isModalOpen: boolean;
  calendarDetails: any;
}) => {
  const {
    handleChange: handleNameChange,
    handleBlur: handleNameBlur,
    value: calendarName,
    setValue: setCalendarName,
  } = useInput(calendarDetails?.value || '', () => true);

  useEffect(() => {
    setCalendarName(calendarDetails?.value || '');
  }, [calendarDetails?.value]);

  const dispatch = useAppDispatch();

  const [isSaving, setIsSaving] = useState(false);

  const onSave = async () => {
    // await dispatch(renameCalendar({ provider: calendarProvider, newName: calendarName }));
    try {
      setIsSaving(true);
      const { title, type, value } = calendarDetails;
      await CalendarService.editCalendarAccount(title, {
        accountType: type === 'microsoft' ? 'ms_teams' : type,
        calendarName: calendarName,
      });
      dispatch(fetchAllAccounts());
      handleClose();
    } catch (err) {
      console.log(err);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <CustomModal handleClose={handleClose} open={isModalOpen}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: { xs: '20px', xl: '24px' },
              backgroundColor: zeplinColor.Neutral1,
              width: '397px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '22px', xl: '32px' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  Rename Calendar
                </Typography>
                <img
                  src={'/assets/close-icon.svg'}
                  alt='close'
                  style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                  onClick={handleClose}
                />
              </Box>
              <CustomTextField
                style={{ width: '100%' }}
                onBlur={handleNameBlur}
                onChange={handleNameChange}
                name='Calendar Name'
                text={calendarName}
                form={true}
                error={false}
                label={'Calendar Names'}
                type='text'
                tabindex={1}
              />
              <Box
                sx={{
                  display: 'flex',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Box
                  onClick={handleClose}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-label='button'
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={() => {
                    onSave();
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: isSaving ? zeplinColor.Neutral4 : zeplinColor.Brand1,
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-label='button'
                    aria-disabled={isSaving}
                  >
                    <Typography
                      variant='buttonMedium'
                      color={isSaving ? zeplinColor.BasicBlack : zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      {isSaving ? 'Renaming....' : 'Rename'}
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
        </Box>
      </CustomModal>
    </>
  );
};

export default CalendarRename;
